module.exports = __webpack_public_path__ + "static/media/joaodebara.5f81f138.jpg";